import React from 'react';
import AnswerButton from '../atoms/Button/AnswerButton';
import styled from "styled-components";

const Answer = (props) => {
    const changeHandler = (event) => {
        props.changeHandler(event.target.value);
    };

    return(
        <AnswerBox>
            {
                [...Array(props.grade)].map((n, index) => {
                    return <AnswerButton key={index} text={index + 1} value={props.direction ? index + 1 : props.grade - index} id={`${props.name}-${index}`} name={props.name} selected={props.value} changeHandler={changeHandler}/>;
                })
            }
        </AnswerBox>
    );
};

const AnswerBox = styled.div`
    margin-top: 14px;
    height: 37px;
    width: 100%;
    box-sizing: border-box;
`;

export default Answer;
